module.exports = __webpack_public_path__ + "img/vision.c81f1a36.jpg";